export { useCustomerDashboard } from '@/contexts/CustomerDashboardContext';
